import React from 'react'
import { Contact, getContacts, deleteContact } from 'utils/ContactsUtils';
import { useAppContext } from 'hooks/useAppContext';
import Grid from 'components/Custom/Grid'
import SkeletonGrid from 'components/Shared/SkeletonGrid';
const phoneNumberFormatter = require('phone-number-formats');

export default function ContactsGrid() {
  const columns = Contact.columns;
  const { selectedProject } = useAppContext(); //Getting the App Context
  const title = "Contacts"
  const getFormPath = () => import('components/Contacts/ContactForm');

  const _columns = columns.map(r => {
    if(r.field.includes("Phone")){
      return {
        ...r,
        render: rowData => (rowData[r.field] ? `${new phoneNumberFormatter(rowData[r.field]).format({type: 'domestic', seperator: "-"})}` : '')
      }
    } else {
      return r
    }
  });

  return (
    selectedProject ?
      <Grid
        columns={_columns}
        title={title}
        getRecords={getContacts}
        deleteRecord={deleteContact}
        selectedProject={selectedProject}
        component="Contacts"
        formPath={getFormPath}
        options={{
          pageSizeOptions: [10, 15, 25],
          pageSize: 10
        }}
      /> : 
      <SkeletonGrid title={title} />
  )
}